import { Button, ButtonVariant } from "@swivl-mono/ui";

interface ScanIncompleteNoticeProps {
  onRetry: () => void;
}

/** Shown when part of the legacy-text scan failed, so an answer can be missing through no fault of the
 * legacy data. An incomplete scan is never cached server-side, so retrying runs it fresh. */
export function ScanIncompleteNotice({ onRetry }: ScanIncompleteNoticeProps): React.ReactElement {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded border border-yellow-200 bg-yellow-50 px-4 py-3">
      <span className="body-sm text-yellow-700">
        Part of the legacy text scan failed, so some answers may be missing below. Scan again before applying.
      </span>
      <Button variant={ButtonVariant.GHOST} onClick={onRetry}>
        Scan again
      </Button>
    </div>
  );
}
